var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleClickSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.068 5.18733L8.00933 6.12867L13.6533 0.484667L14.596 1.42733L8.00933 8.014L3.76667 3.77133L4.70933 2.82867L6.126 4.24533L7.068 5.18667V5.18733ZM7.06933 3.302L10.3707 0L11.3107 0.94L8.00933 4.242L7.06933 3.302ZM5.18467 7.072L4.24267 8.014L0 3.77133L0.942667 2.82867L1.88467 3.77067L1.884 3.77133L5.18467 7.072V7.072Z",
    fill: "#19AB4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleClickSuccess);
export default __webpack_public_path__ + "static/media/double_click_success.805f59534e8d06f365ab8f83c7fa9d9e.svg";
export { ForwardRef as ReactComponent };